import { render } from "./UserViewResume.vue?vue&type=template&id=3004b0d2&ts=true"
import script from "./UserViewResume.vue?vue&type=script&lang=ts"
export * from "./UserViewResume.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__